<div data-cy="workflows__page" style="margin: 5em auto">
    <!-- <mat-progress-bar *ngIf="isProcess" mode="indeterminate"></mat-progress-bar> -->
</div>
<app-workflow-generic data-cy="workflows__workflow-generic" *ngIf="hasModule('workflow')" [load]="true" [margin]="false" parentType="actions_overview"></app-workflow-generic>
